import { Link, useLocation } from "react-router-dom";

const Navbar = () => {

  const location = useLocation();

  const navLinkStyle = (path) => ({
    color: location.pathname === path ? "#111827" : "#fff",
    background:
      location.pathname === path
        ? "#fff"
        : "transparent",
    padding: "10px 18px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "600",
    transition: "0.3s",
  });

  return (
    <div
      style={{
        background:
          "linear-gradient(90deg, #111827, #1f2937)",
        padding: "15px 40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        position: "sticky",
        top: "0",
        zIndex: "999",
      }}
    >

      {/* LOGO */}
      <div
        style={{
          color: "#fff",
          fontSize: "24px",
          fontWeight: "bold",
          letterSpacing: "1px",
        }}
      >
        MERN News
      </div>

      {/* NAV LINKS */}
      <div
        style={{
          display: "flex",
          gap: "15px",
          alignItems: "center",
        }}
      >

        <Link
          to="/"
          style={navLinkStyle("/")}
        >
          Home
        </Link>

        <Link
          to="/bookmarks"
          style={navLinkStyle("/bookmarks")}
        >
          Bookmarks
        </Link>

        <Link
          to="/login"
          style={navLinkStyle("/login")}
        >
          Login
        </Link>

   

      </div>
    </div>
  );
};

export default Navbar;